import {Tls} from '../tools/Tls';
import * as L from 'leaflet'

var DrawTls = {
    degrees: [],
    getDegrees() {
        if (this.degrees.length > 0) return this.degrees;
        var d = [];
        var nSlice = 24;
        for (var i = 0; i < nSlice; i++) {
            d.push(2 * Math.PI * i / nSlice);
        }
        return d;
    },
    drawCircle(mymap, centerX, centerY, dx) {
        var dgArr = this.getDegrees();
        var points = [];
        for (var i = 0; i < dgArr.length; i++) {
            points.push(Tls.u(
                centerX + dx * Math.sin(dgArr[i]),
                centerY + dx * Math.cos(dgArr[i]),
            ));
        }

   

        var m = L.polygon(points, { weight: 1, color: '#000', fillColor: "#000", fillOpacity: 1 }).addTo(mymap);

return m;

    },
    drawRectangle(mymap, centerX, centerY, dx, dy, angle) {
        // angle in radian

        var c = Math.cos(angle);
        var s = Math.sin(angle);



        // x: Math.cos(angle) * (pointX-originX) - Math.sin(angle) * (pointY-originY) + originX,
        // y: Math.sin(angle) * (pointX-originX) + Math.cos(angle) * (pointY-originY) + originY


    let    p = [
            [-dx, -dy],
            [+dx, -dy],
            [+dx, +dy],
            [-dx, +dy],
            [-dx, -dy],
        ];

        // TODO Important add 2 row === poleP, skinP if not exist craete it

        // rotate:
     let   points = [];

        for (var i = 0; i < p.length; i++) {

            points[i] = Tls.u(
                c * p[i][0] - s * p[i][1] + centerX,
                s * p[i][0] + c * p[i][1] + centerY,
            );
        }





        // points = [
        //     Tls.u(centerX-dx,centerY-dy),
        //     Tls.u(centerX+dx,centerY-dy),
        //     Tls.u(centerX+dx,centerY+dy),
        //     Tls.u(centerX-dx,centerY+dy),
        //     Tls.u(centerX-dx,centerY-dy),
        // ];

         L.polygon(points, { weight: 1, color: '#000', fillColor: "#fff", fillOpacity: 1 }).addTo(mymap);


        points = [];
        for ( i = 0; i < p.length; i++) {
            points[i] = [
                c * p[i][0] - s * p[i][1] + centerX,
                s * p[i][0] + c * p[i][1] + centerY,
            ];
        }


        return points;

        // if (ll[0].lat < ll[1].lat) return ll;
        // else return ll.reverse();

    }
}

export {DrawTls}